<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="">
              <el-radio-group size="medium" v-model="source" @change="changeSelc">
                  <el-radio-button label="saas">系统</el-radio-button>
                  <el-radio-button disabled label="openapi">开放平台</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="名称">
              <el-input v-model="searchCondition.channel_name" placeholder="输入账户名称" clearable style="width:200px"></el-input>
            </el-form-item> -->
            <el-form-item label="日期">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row class="actionBtn" style="display:flex;justify-content: space-between;">
          <ScreeCompany @ScreeCompany="ScreeCompany"/>
			<div v-show="source == 'saas'">
				<el-button size="mini" type="danger" @click="refuse('', '2',true)">拒绝</el-button>
				<el-button size="mini" type="primary" @click="showTG('', '1',true)">通过</el-button>
			</div>
			<div v-show="source == 'openapi'">
				<el-button size="mini" type="primary" @click="event_checkApi('', '2',true)">修改审核结果</el-button>
			</div>
        </el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label" :key="index" :name="item.name" class="tab-item">
          </el-tab-pane>
          <ApeTable ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" :current_Page="currentPage" @switchPaging="switchPaging" highlight-current-row 
          @selectList="event_selectList"
          >
          <!-- <el-table-column
            slot="first-column"
            width="180"
            align="center"
            label="ID">
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            width="200"
            align="center"
            label="公司名">
            <template slot-scope="scope">
              {{ scope.row.company_name}}
            </template>
          </el-table-column> -->
			<template #first-column>
				<el-table-column type="selection" width="55" :selectable="event_selectable">
				</el-table-column>
			</template>
          <el-table-column
            slot="second-column"
            align="center"
            label="公司名称">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.id" placement="top">
                <div>{{ scope.row.company_name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              slot="second-column"
              width="100"
              align="center"
              label="确认函">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="mxPreview(scope.row.bill_file_url_two)" >
                  <i class="iconfont iconwenjian iconbtn iconBtns"></i>
                </el-button>
                <el-button size="mini" type="text" @click="mxGoUrl(scope.row.bill_file_url_two)">
                  <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                </el-button>
              </template>
            </el-table-column>
          <el-table-column
            slot="second-column"
            width="100"
            align="center"
            label="结算清单">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="mxPreview(scope.row.file_url)">
                  <i class="iconfont iconwenjian iconbtn iconBtns" @click="downButton(scope.row)"></i>
                </el-button>
                <el-button size="mini" type="text" @click="mxGoUrl(scope.row.file_url)">
                  <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
            slot="second-column"
            width="100"
            align="center"
            label="业务清单">
              <template slot-scope="scope">
                <div v-if="scope.row.bill_file_url">
                  <el-button size="mini" type="text" @click="mxPreview(scope.row.bill_file_url)">
                    <i class="iconfont iconwenjian iconbtn iconBtns" @click="downButton(scope.row)"></i>
                  </el-button>
                  <el-button size="mini" type="text" @click="mxGoUrl(scope.row.bill_file_url)">
                    <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                  </el-button>
                </div>
                <div v-else>
                  等待上传
                </div>
              </template>
            </el-table-column>
            <el-table-column
              slot="second-column"
              prop="money"
              align="center"
              sortable
              label="成功金额">
              <template slot-scope="scope">
                <div class="tag-group">
                  <el-tag type="warning" class="tag-item">
                    <div>成功金额：{{scope.row.succeed_money}}</div>
                  </el-tag>
                  <el-tag type="warning" class="tag-item">
                    <div>成功人数：{{scope.row.succeed_num}}</div>
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width="200"
              align="center"
              label="操作">
              <template slot-scope="scope">
                <span>
                  <el-button size="mini" type="danger" v-if="scope.row.bill_status == 0&&userPermissions.indexOf('bill_audit') != -1"  @click="refuse(scope.row.bill_id, '2')">拒绝</el-button>
                  <el-button size="mini" type="primary" @click="showTG(scope.row.bill_id, '1')" v-if="scope.row.bill_status == 0&&userPermissions.indexOf('bill_audit') != -1">通过</el-button>
                  <el-popover
                    v-if="userPermissions.indexOf('bill_audit') != -1 && scope.row.bill_status === 1"
                    placement="top"
                    width="100"
                    v-model="scope.row.visible">
                    <p>确定要强制驳回吗？</p>
                    <div style="text-align: right; margin: 0;">
                      <el-button size="mini" @click="scope.row.visible=false">取消</el-button>
                      <el-button type="danger" size="mini" @click="forceRefuse(scope.row.bill_id, 4)">确定驳回</el-button>
                    </div>
                    <el-button slot="reference" type="danger" size="mini">强制驳回</el-button>
                  </el-popover>
                </span>
              </template>
            </el-table-column>
          </ApeTable>
        </el-tabs>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="refuseData" :rules="refuseRules" ref="refuseForm" label-position="right" label-width="96px">
          <el-radio-group v-model="reason" class="reason" @change="changeReason">
            <el-radio v-for="(item, index) in this.rejectList" :label="item.label" :key="index" :name="item.name" class="tab-item">{{item.name}}</el-radio>
          </el-radio-group>
          <el-form-item label="拒绝原因" prop="desc">
            <el-input v-model="refuseData.desc" type="textarea" :rows="5" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
    <verification
      @dialogChanged="dialogBillChanged($event)"
      @onSuccess="handleBillSuccess($event)"
      :dialogBillVisible="dialogBillVisible"
      :billId="billId" />
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import DatePicker from '@/components/DatePicker.vue'
import Verification from '@/components/Verification.vue'
import ScreeCompany from '@/components/ScreeCompany.vue'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    DatePicker,
    Verification,
    ScreeCompany
  },
  data() {
    return {
      MultSelectList:[],
      rejectList: [
        {
          label: 1,
          name: '服务金额与附件表中金额不符'
        },
        {
          label: 2,
          name: '服务金额是实际下发金额，不含税'
        },
        {
          label: 3,
          name: '确认函未盖章'
        },
        {
          label: 4,
          name: '业务清单结算依据和结算量填写不正确'
        }
      ],
      reason: '',
      currentPage: 1,
      refuseData: {//拒绝提交数据
        desc: ''
      },
      refuseRules: {
        desc: [
         { required: true, message: '请输入拒绝原因', trigger: 'blur' },
        ]
      },
      activeName: 'untreated',
      tabsList: [
        {
          label: '未处理',
          name: 'untreated'
        },
        {
          label: '已处理',
          name: 'reviewed'
        },
      ],
      billId: '',
      dialogBillVisible: false,
      source: 'saas',
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      searchCategory: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: false,
      columns: [
        // {
        //   title: '任务名称',
        //   value: 'name',
        //   header_align: 'center',
        //   align: 'center',
        // },
        {
          title: '创建时间',
          value: 'created_at',
          header_align: 'center',
          align: 'center',
        },
        // {
        //   title: '成功金额',
        //   value: [
        //     // {label:'总金额：', value:'total_amount'},
        //     // {label:'人员数：', value:'total_num'},
        //     // {label:'成功金额：', value:'succeed_money'},
        //     // {label:'失败金额：', value:'failed_money'},
        //     {label:'成功金额：', value:'succeed_money'},
        //     {label:'成功人数：', value:'succeed_num'},
        //   ],
        //   header_align: 'center',
        //   align: 'center',
        //   width: 200
        // },
        {
          title: '提交时间',
          value: 'bill_created_at',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '结算状态',
          value: 'alias_status',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '审核状态',
          value: 'alias_bill_status',
          width: 100,
          header_align: 'center',
          align: 'center',
        },
      ],
      // 表格列表数据
      dataList:[  ],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 添加附件
      dialogData:{
        visible: false,
        title: '系统操作',
        width: '30%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentCompanyId:0,
    }
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    },
    "refuseData.desc" : function(v) {
      if(v) {
        this.dialogData.loading = false
      }else {
        this.dialogData.loading = true
      }
    },
    "reason": function(v) {
      if(v) {
        this.dialogData.loading = false
        this.rejectList.forEach(item => {
          if(item.label == v) {
            this.refuseData.desc = item.name
          }
        })
      }else {
        this.dialogData.loading = true
      }
    }
  },
  methods: {
      // 是否禁用
      event_selectable(row){
      if(row.alias_bill_status == '等待审核中'){
		return true
      }
      },
      // 多选
      event_selectList(e){
        this.MultSelectList = e
      },
      showTG(arg,val,isMult){
        if(isMult){
            if(this.MultSelectList.length == 0){
               this.$message.warning('至少选择一项')
            }else{
                this.$confirm('确定要通过吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
				this.viewButton(arg,val,isMult)
				}).catch(() => {
            })
            }
        }else{
            this.$confirm('确定要通过吗？', '提示', {
                 confirmButtonText: '确定',
                 cancelButtonText: '取消',
                 type: 'warning'
                 }).then(() => {
                    this.viewButton(arg,val)
            }).catch(() => {
            
            })   
        }
    },
    // 重置分页
    async resetPage() {
      this.$refs.apeTable.currentPage = 1
    },
    //选择原因
    changeReason() {
      this.rejectList.forEach(item => {
        if(item.label == this.reason) {
          this.refuseData.desc = item.name
        }
      })
    },
    /*确定外层弹窗*/
    forceRefuse:debounce(async function(id,type){
      let args = {
        id,
        type, // 1-成功 2-失败 3-禁用 4 - 强制驳回
      }
      let info = await this.$api.saveAdminBillAudit(args)
      if (info) {
        this.$message.success('操作成功!')
        this.init()
      } else {
        this.$message.error(info)
      }
    },1000,{leading:true,trailing:false}),
    //拒绝
    refuse(id, type, isMult=false) {
      if(isMult){
        if(this.MultSelectList.length == 0){
           this.$message.warning('至少选择一项')
		}else{
           this.dialogData.visible = true
           this.refuseData.id = id
           this.refuseData.type = type
		}
      }else{
        this.dialogData.visible = true
        this.refuseData.id = id
        this.refuseData.type = type
      }
    },
    //切换tab
    async handleClick(tab) {
      if(tab.name == 'untreated') {//等待用户上传
        this.searchCondition.type = 0
        this.init(0)
      }else if(tab.name == 'reviewed') {//审核中
        this.searchCondition.type = 1
        this.init(1)
      }
      this.resetPage()
    },
    ScreeCompany(v, name) {
      if (name == 'company') {
        if(v) {
          this.searchCondition.company_id = v
        } else {
          delete this.searchCondition.company_id
        }
        this.init('search')
      }

      if(name == 'settlement') {
        if (v) {
          this.searchCondition.channel_account = v
        } else {
          delete this.searchCondition.channel_account
        }
        this.init('search')
      }
    },
    //切换系统
    changeSelc() {
      console.log(this.source, "saas")
    },
    // 搜索
    searchButton() {
      this.init()
    },
    // 切换页码操作
    async switchPaging(val) {
      if(val) {
        this.currentPage = val
      }else {
        this.currentPage = 1
      }
      this.init()
    },
    // 响应详情按钮
    async viewButton(id, type) {
      this.formData.id = id
      this.formData.type = type
      this.formSubmit()
    },
    handleBillSuccess() {
      this.$message.success('验证成功')
      this.dialogBillVisible = false
    },
    dialogBillChanged(state) {
      this.dialogBillVisible = state
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
    // 初始化列表
    async init(type) {
      if(type) {
        this.mxResetPage()
      }
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if(type == 0) {
        this.searchCondition.type = 0
        pagingInfo.current_page = 1
      }
      if(type) {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let { data, pages} = await this.$api.getAdminBillList(searchCondition)
      this.$nextTick(() => {
        this.dataList = data
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.id) {
        condition.id = this.searchCondition.id
      }
      if (this.searchCondition.channel_name) {
        condition.channel_name = this.searchCondition.channel_name
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }
      condition.type = 0
      if(this.searchCondition.type || this.searchCondition.type == 0) {
        condition.type = this.searchCondition.type
      }
      if (this.searchCondition.company_id || this.searchCondition.channel_account) {
        condition.company_id = this.searchCondition.company_id
        condition.channel_account = this.searchCondition.channel_account
      }
      return condition
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      this.formData.company_id = this.currentCompanyId
      let ids = []
      this.MultSelectList.map(item=>{
        ids.push(item.bill_id)
      })
      
      if(this.formData.id){
          let id = await this.$api.saveAdminBillAudit(this.formData)
            this.$nextTick(() => {
            this.dialogClose()
          })
            this.$nextTick(() => {
            if (id) {
              this.$message.success('保存成功!')
              this.init()
            }
        })
      }else{
            let res = await this.$api.saveAdminBillAuditBatch({
                ids:ids,
                type:this.formData.type
            })
            this.$nextTick(() => {
            this.dialogClose()
            })
            this.$nextTick(() => {
              if (res) {
                this.$message.success('保存成功!')
                this.init()
              }
            })
      }
    },
    async formRefuseSubmit( ){
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      // this.refuseData.company_id = this.currentCompanyId
      let ids = []
      this.MultSelectList.map(item=>{
        ids.push(item.bill_id)
      })
      if(this.refuseData.id){
          let id = await this.$api.saveAdminBillAudit(this.refuseData)
          this.$nextTick(() => {
            this.dialogClose()
          })
          this.$nextTick(() => {
            if (id) {
              this.$message.success('保存成功!')
              this.init()
            }
          })
      }else{
		let res = await this.$api.saveAdminBillAuditBatch({
			ids:ids,
			type:this.refuseData.type,
			desc:this.refuseData.desc
		})
        this.$nextTick(() => {
          this.dialogClose()
        })
        this.$nextTick(() => {
          if (res) {
            this.$message.success('保存成功!')
            this.init()
          }
        })
      }

    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['refuseForm'].validate((valid) => {
        if (valid) {
          this.formRefuseSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.reason = ''
      // this.formData = {}
      // this.attachmentUploadFileList = []
      this.refuseData = {}
    },
    keyupSubmit(){
      document.onkeydown = () => {
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },
  },
  created() {
    this.keyupSubmit()
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
   .actionBtn
    display:flex;justify-content: space-between;
  .el-row::after,.el-row::before
    content: none
  .el-button
    margin-right 4px
    margin-bottom 4px
  .el-button + .el-button
    margin-left: 0
  .table-header
    margin-bottom 12px
  .el-input-group__prepend, .el-input-group__append
    background #ffffff
    padding 0 12px
  .el-input-group__append
    color #ffffff
    background #1890ff
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .table-right
    float right
  .changeBtn
    display: flex
    flex-direction: row
    width: 1110px
  // .demo-form-inline
  //   padding-top: 20px
  .iconBtns
    font-size 20px
    color rgba(0, 183, 158, 1)
  .el-form--inline .el-form-item
    margin-right: 30px
  .reason
    display: flex
    flex-direction: column
    padding-left: 20px
  .tag-group
    display: flex
    flex-direction: column
  .tag-item
    margin: 5px 0
  // .table-search
  //   height: 36px
</style>
